'use client'

import { Link } from 'next-view-transitions'
import { usePathname } from 'next/navigation'

import styles from './index.module.css'

export default function Index() {
  const $pathname = usePathname();
  const nav = [
    {
      link: '/',
      label: '首页',
      prefetch: false,
    },
    {
      link: '/category',
      label: '标签',
    },
    {
      link: '/about',
      label: '关于我',
    },
    {
      link: 'https://github.com/ZhuAiQuan/ZhuAiQuan/discussions/2',
      label: '留言板'
    }
    // {
    //   link: '/profie',
    //   label: 'profie'
    // },
    // {
    //   link: '/more',
    //   label: 'more',
    // },
    // {
    //   link: '/search',
    //   label: 'search'
    // }
  ]
  return (
    <nav className={styles['nav-context']}>
      {
        nav.map(item => <Link href={item.link} key={item.label} prefetch={item.prefetch ?? false} className={`${styles['nav-link']} ${$pathname === item.link ? styles['nav-link-active'] : ''}`}>{item.label}</Link>)
      }
    </nav>
  )
}
